import i18n from 'i18next';
import { NavigationStore } from '@24i/nxg-core-utils/src/globalSingletons';
import { Payload, TitleForSpecialScreens } from './types';

// we need to move this enum from smartott package to here (this package)
export enum SPECIAL_TRANSLATED_SCREENS {
    PLAYBACK = 'appstage-screen-player',
    DETAILS = 'appstage-screen-details',
    SEE_ALL = 'appstage-screen-see-all',
}

export enum SPECIAL_TRANSLATED_TV_SCREENS {
    PLAYBACK = 'Playback',
    DETAILS = 'Details',
    SEE_ALL = 'SeeAll',
}

export const handleTitleForSpecialScreens = ({
    screen,
    params,
    screenTitle,
}: TitleForSpecialScreens): string => {
    switch (screen) {
        case SPECIAL_TRANSLATED_SCREENS.SEE_ALL:
        case SPECIAL_TRANSLATED_TV_SCREENS.SEE_ALL: {
            const title = params.payload?.params?.title || params.payload.params?.asset?.title;
            return i18n.t('analytics.documentTitle.seeAll', { rowTitle: title });
        }
        case SPECIAL_TRANSLATED_SCREENS.DETAILS:
        case SPECIAL_TRANSLATED_TV_SCREENS.DETAILS: {
            return i18n.t('analytics.documentTitle.detail', {
                assetTitle: params.payload?.asset?.title,
            });
        }
        case SPECIAL_TRANSLATED_SCREENS.PLAYBACK:
        case SPECIAL_TRANSLATED_TV_SCREENS.PLAYBACK: {
            const title = params.payload?.params?.title || params.payload.params?.asset?.title;
            return i18n.t('analytics.documentTitle.player', { assetTitle: title });
        }
        default:
            return screenTitle || '';
    }
};

export const getFormattedOriginalSourcePage = (payload: Payload): string => {
    const previousState = NavigationStore.getPreviousState();
    return handleTitleForSpecialScreens({
        screen: previousState?.routeId || '',
        params: payload,
        screenTitle: previousState?.title,
    });
};
